import { render } from "./inoutDetail.vue?vue&type=template&id=15a2dc86&scoped=true"
import script from "./inoutDetail.vue?vue&type=script&lang=js"
export * from "./inoutDetail.vue?vue&type=script&lang=js"

import "./inoutDetail.vue?vue&type=style&index=0&id=15a2dc86&lang=scss"
import "./inoutDetail.vue?vue&type=style&index=1&id=15a2dc86&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a2dc86"]])

export default __exports__